module.exports = __webpack_public_path__ + "static/media/de.aeb60257.svg";